import React, { useEffect } from "react";
import { withRouter } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import { VALIDATE_ACH_BANK_DETAILS } from "../../../../store/actions/actionTypes";
import "./index.css";

import Button from "../../../../components/formElements/button/Button";
import TextInput, {
  TextInputWithHelpText,
} from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import SpinnerBorder from "../../../../components/uiElements/loadingSpinner/SpinnerBorder";

const ACHBankDebit = ({
  accountDetails,
  form,
  validateData,
  verifyBankAccount,
  setBankDetails,
  addACHBankDetails,
  getCustomerBankDetails,
  deleteACHBankDetails,
  onPayment,
}) => {
  useEffect(() => {
    getCustomerBankDetails();
  }, [getCustomerBankDetails]);

  useEffect(() => {
    if (form && form.accountValid) {
      addACHBankDetails();
    }
    form.accountValid = false;
    // eslint-disable-next-line
  }, [form]);

  const { selectedSubscription, achBankDetails, paymentError } = accountDetails;

  return (
    <>
      <div
        style={{
          marginTop: "10%",
        }}
        className="row"
      >
        <Row
          className={classnames(
            "mx-auto",
            achBankDetails?.ach_fetched && "disable"
          )}
        >
          <Col size={["md-12"]} className="">
            <TextInput
              error={form.accountHolderName}
              type="text"
              label="Account Holder Name"
              value={achBankDetails?.ach_account_holder_name}
              onChange={value =>
                setBankDetails({
                  ach_account_holder_name: value,
                })
              }
            />
          </Col>
          <Col size={["md-12"]} className="mb-2">
            <TextInputWithHelpText
              error={form.accountNumber}
              type={!achBankDetails?.ach_fetched ? "number" : "text"}
              maxLength={12}
              label="Account Number"
              value={achBankDetails?.ach_account_number}
              onChange={value =>
                setBankDetails({
                  ach_account_number: value,
                })
              }
              helpText={"Account Number must be 12 digit numberic"}
            />
          </Col>

          <Col size={["md-12"]} className="mt-2">
            <TextInputWithHelpText
              error={form.routingNumber}
              type="number"
              maxLength={9}
              label="Routing Number"
              value={achBankDetails?.ach_routing_number}
              onChange={value =>
                setBankDetails({
                  ach_routing_number: value,
                })
              }
              helpText={"Routing Number must be 9 digit numeric"}
            />
          </Col>
        </Row>
        <Row className="paymentErrorContainer mx-auto text-center mt-n3 mb-2">
          <p className="text-danger">{paymentError}</p>
        </Row>
        <Row className="col-md-12 mx-auto content-center">
          {achBankDetails &&
            achBankDetails?.status !== "verified" &&
            achBankDetails?.ach_fetched && (
              <Button
                type="info"
                className={classnames("w-25 mx-auto")}
                label={
                  accountDetails?.bankAccountLoading ? (
                    <SpinnerBorder />
                  ) : (
                    <span>Verify</span>
                  )
                }
                onClick={() => verifyBankAccount(achBankDetails)}
              />
            )}
          {achBankDetails &&
            achBankDetails?.status === "verified" &&
            achBankDetails?.ach_fetched && (
              <Button
                type="info"
                className={classnames("w-25")}
                label={
                  accountDetails?.addSubscriptionLoading ? (
                    <SpinnerBorder />
                  ) : (
                    <span>{`Pay $${selectedSubscription?.unit_amount}`}</span>
                  )
                }
                onClick={() => onPayment("bank")}
              />
            )}
          {!achBankDetails?.ach_fetched && (
            <Button
              type="info"
              className={classnames("w-25 mx-auto content-center h-75")}
              label={
                accountDetails?.bankAccountLoading ? (
                  <SpinnerBorder />
                ) : (
                  <span>Add</span>
                )
              }
              onClick={() => validateData(achBankDetails)}
            />
          )}
          {achBankDetails?.ach_fetched && (
            <Button
              type="outline"
              className={classnames("w-25 mx-2")}
              label={
                accountDetails?.deleteAccountLoading ? (
                  <SpinnerBorder />
                ) : (
                  <span>Remove</span>
                )
              }
              onClick={() => deleteACHBankDetails(achBankDetails?.ach_bank_id)}
            />
          )}
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth, api, validation }) => ({
  accountDetails: onboarding?.accountDetails,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  setBankDetails: updatedData => dispatch(actions.setBankDetails(updatedData)),
  validateData: achBankdetails =>
    dispatch(actions.validateData(VALIDATE_ACH_BANK_DETAILS, achBankdetails)),
  verifyBankAccount: cb => dispatch(actions.verifyBankAccount(cb)),
  addACHBankDetails: () => dispatch(actions.addACHBankDetails()),
  getCustomerBankDetails: () => dispatch(actions.getCustomerBankDetails()),
  deleteACHBankDetails: id => dispatch(actions.deleteACHBankDetails(id)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ACHBankDebit)
);
